import { sidebarNodeTypes } from '../../../config/config';
import { getApiForNodeType } from '../../common/api/api-map';
import { BaseApi } from '../../common/api/base-api.interface';
import { FreeDrawNodeCreateProps } from '../models/free-draw-node-create-props';
import { gojsPenCursor } from './../../../assets/cursors';
import { createFreeDrawNode } from './create-free-draw-node';
import { setupFreeDrawNode } from './setup-free-draw-node';

export const freeDrawNodeAPI = (): BaseApi<FreeDrawNodeCreateProps> => ({
  name: sidebarNodeTypes.freeDraw,
  setup: setupFreeDrawNode,
  create: createFreeDrawNode,
  getCursor: () => gojsPenCursor,
  ...getApiForNodeType(sidebarNodeTypes.freeDraw),
});
